module.exports = __webpack_public_path__ + "img/main-bg.90f5027d.jpg";